import * as Scrivito from "scrivito";
import { sectionColors } from "^/config/attributeConsts";

const SectionContentWidget = Scrivito.provideWidgetClass(
  "SectionContentWidget",
  {
    attributes: {
      content: "widgetlist",
      useFullWidth: ["enum", { values: ["yes", "no"] }],
      padding: [
        "enum",
        { values: ["py-0", "py-1", "py-2", "py-3", "py-4", "py-5"] },
      ],
      largeTopPadding: "boolean",
      background: ["reference", { only: ["Image", "Video"] }],
      backgroundColor: [
        "enum",
        {
          values: sectionColors,
        },
      ],
    },
    extractTextAttributes: ["content"],
  }
);

export default SectionContentWidget;
